'use client'

import { SelectContent } from '@radix-ui/react-select'
import { IInquiryDocumentUpload, ILoadDocuments } from '@repo/sdk'
import {
  Button,
  Select,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Spinner,
  useDropzoneContext,
} from '@repo/ui'

export const DroppedDocument = ({
  document,
  removeDocument,
  updateDocument,
}: {
  document: IInquiryDocumentUpload
  removeDocument: () => void
  updateDocument: (params: Partial<IInquiryDocumentUpload>) => void
}) => {
  const { documentTypes } = useDropzoneContext()

  return (
    <tr>
      <td className={'max-w-48 text-wrap py-2 pr-5'}>{document.file.name}</td>
      <td>
        {document.status === 'pending' ? (
          <div className={'flex items-center justify-center'}>
            <Spinner className="size-3" />
          </div>
        ) : (
          <>
            <Select
              onValueChange={(type: ILoadDocuments['type']) => updateDocument({ type })}
              value={document.type}
            >
              <SelectTrigger className="border-0 bg-transparent px-0 focus:ring-0 focus:ring-offset-0">
                <SelectValue />
              </SelectTrigger>
              <SelectContent
                align="start"
                className="bg-popover shadow-md"
                position="popper"
                side="bottom"
              >
                {documentTypes.map(doc => (
                  <SelectItem key={doc.type} value={doc.type}>
                    {doc.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-destructive">{document.error && document.error.message}</p>
          </>
        )}
      </td>
      <td className={'flex items-center justify-end'}>
        {document.status === 'pending' ? null : (
          <Button
            className="bg-none p-1 text-right text-brand hover:text-destructive hover:no-underline"
            onClick={removeDocument}
            type="button"
            variant="noStyle"
          >
            Delete
          </Button>
        )}
      </td>
    </tr>
  )
}
